import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class PlanoFamiliaService extends ServiceCRUD {
  private baseUrlService: string;

  constructor(public httpClient: HttpClient, router: Router) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/plano_familia`;
  }

  public getDados(data_inicial?: any, data_final?: any, dealer?: any, idRegional?: any): Observable<any> {

    return this.httpClient.get<any>(`${this.baseUrlService}/plano_familia/consultar_plano`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealer', dealer.toString())
        .set('regional', idRegional.toString())
    });
  }

  public getModelos(idFamilia: number, idDealer: number, nomeFamilia: string, data_inicial: any): Observable<any> {
    return this.httpClient.get<any>(
      `${this.baseUrlService}/plano_familia/consultar_plano_modelos?id_familia=${idFamilia}&id_dealer=${idDealer}&familia=${nomeFamilia}&data_inicial=${data_inicial}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      })
    });
  }

  public atualizarQuantidadeProducaoEmLote(payload: any[]): Observable<any> {
    return this.httpClient.put(
      `${this.baseUrlService}/plano_familia/quantidade_producao`,
      payload,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
        })
      }
    );
  }


}
